import { render } from "./SusHit.vue?vue&type=template&id=46aff479"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/SusHit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46aff479"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46aff479', __exports__)) {
    api.reload('46aff479', __exports__)
  }
  
  module.hot.accept("./SusHit.vue?vue&type=template&id=46aff479", () => {
    api.rerender('46aff479', render)
  })

}


export default __exports__